import * as React from 'react'
import { accentUtils, t, showDialog, from } from '../services/HelperService'
import { AccentComboUnbound, AccentMultiComboUnbound } from '../controls/unbound/AccentComboUnbound'
import { getProduct, getUserProductList, productVersionDisplayText } from '../services/ProductService'
import { ProductItemTemplate } from '../controls/products/ProductItemTemplate'
import { AccentDialog } from './AccentDialog'
import { AccentButton } from '../controls/AccentButton'
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { filterBy } from '@progress/kendo-data-query';
import { isMobileOnly } from '../controls/AccentDisplay'
import { queryNoTracking } from '../services/DataService'


const query_ProductCategoryMappings = queryNoTracking("ProductCategoryMappings");
export function selectProduct(props) {

    return new Promise(p => {
        showDialog(<ProductSelectionDlg {...props} />).then(s => {
            p(!s.canceled ? s.product : null);
        });
    });

};


function getSelectProductFromProductVersionID(e) {

    const productID = accentUtils.isEmpty(e) ? null : e.split('_')[0];
    let versionID = accentUtils.isEmpty(e) ? null : e.split('_')[1];

    if (accentUtils.isEmpty(productID)) return null;

    if (versionID === "null") {
        versionID = null;
    }

    return { productID: productID, versionID: versionID };

}

export const ProductSelectionDlg = React.memo(props => {

    

    const [allData,] = React.useState(getUserProductList({ ...props,  includeDraft: props.includeDraft }).filter(i => (!props.selectMultiple || !accentUtils.isEmpty(i.ID)) && !from(props.excludeIDs ? props.excludeIDs : []).any(ex => ex.toUpperCase() == i.ID.toUpperCase())).map(x => ({ ...x, ProductVersion: productVersionDisplayText(x), product_version_id: `${x.ID}_${x.VersionID ?? accentUtils.getEmptyGuid()}` })));
    const [product, setProduct] = React.useState(props.selectMultiple ? [] : null);
    const [categoryMappings, setCategoryMappings] = React.useState([]);


    const onChanged = React.useCallback((e) => {

        setProduct(e);

    }, [setProduct]);

   

    // Kendo Grid state for multi-select
    const [filter, setFilter] = React.useState();
    const selectionIdField = 'product_version_id';

    const onFilterChange = React.useCallback((e) => {
        setFilter(e.filter);
    }, []);

    const gridData = React.useMemo(() => {
        if (categoryMappings.length === 0) return allData;

        const categoryMap = from(categoryMappings).toDictionary(k => k.ProductID.toUpperCase());

        return allData.map(product => {
            const mapping = categoryMap.get(product.ID.toUpperCase());
            return {
                ...product,
                Category: mapping ? mapping.Description : ''
            };
        });
    }, [allData, categoryMappings]);


    const processedData = React.useMemo(() => filterBy(gridData, filter), [gridData, filter]);

    const onSelectionChange = React.useCallback((event) => {
        const currentId = event.dataItem[selectionIdField];
        let newSelected = [...product];
        if (product.includes(currentId)) {
            newSelected = newSelected.filter(id => id !== currentId);
        } else {
            newSelected.push(currentId);
        }
        setProduct(newSelected);
    }, [product]);

    const onHeaderSelectionChange = React.useCallback((event) => {
        const checked = event.syntheticEvent.target.checked;
        if (checked) {
            setProduct(processedData.map(item => item[selectionIdField]));
        } else {
            setProduct([]);
        }
    }, [processedData]);

    const dataWithSelection = React.useMemo(() =>
        processedData.map(item => ({
            ...item,
            selected: product?.includes(item[selectionIdField])
        })), [processedData, product]);



    const onClose = React.useCallback((e, canceled) => {

        const result = props.selectMultiple ? product?.map(getSelectProductFromProductVersionID) : getSelectProductFromProductVersionID(product);

        props.onClose({ canceled: canceled, product: result });        
    },[props, product]);



    const isValid = props.allowEmpty || !accentUtils.isNull(product);
    const mobile = isMobileOnly;

    React.useEffect(() => {

        if (props.selectMultiple && !mobile) {

            query_ProductCategoryMappings.getAll({}).then(categories => {
                setCategoryMappings(categories);
            });

        }

    }, [props.selectMultiple, mobile]);




    return <AccentDialog
        headerContent={t("application_strings.application.dialogs.productSelectionTitle")}
        maxWidth={800}
        onClose={props.onClose}
        actionsContent={[
            <AccentButton key="2" tagName="ptCloseBtn" disabled={!isValid} onClick={e => onClose(e, false)}>{t("application_strings.application.buttons.ok")} </AccentButton>
        ]}
    >
        <div id="productSelectionDlg" className="center">

            {props.selectMultiple && (
                mobile ?
                    <AccentMultiComboUnbound displayField="Product" valueField="product_version_id" onChange={onChanged} label="application_strings.application.dialogs.productSelectionTitle" data={allData} itemRender={ProductItemTemplate} />
                    :
                    <Grid
                        data={dataWithSelection}
                        style={{ height: '400px', maxWidth: '800px' }}
                        selectedField="selected"
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                        filterable={true}
                        filter={filter}
                        onFilterChange={onFilterChange}
                    >
                        <GridColumn
                            field="selected"
                            width="50px"
                            filterable={false}
                            headerSelectionValue={
                                processedData.length > 0 && product?.length === processedData.length
                            }
                        />
                        <GridColumn field="Product" title={t("Product Name")} />
                        <GridColumn field="ProductCode" title={t("Product Code")} />
                        <GridColumn field="ProductVersion" title={t("Version")} />
                        <GridColumn field="Category" title={t("Category")} />
                    </Grid>
            )}
            {!props.selectMultiple && <AccentComboUnbound displayField="Product" valueField="product_version_id" onChange={onChanged} label="application_strings.application.dialogs.productSelectionTitle" data={allData} itemRender={ProductItemTemplate} />}
        </div>
    </AccentDialog>;
});